import styled from 'styled-components';
import { Valence } from '../../../../../../../../../../common/model/types';
import { useImpactChartContext, useImpactChartHeights, useImpactChartWidths } from '../../../context';
import { StackedBar } from '../../stacked-bar';
import { DimensionRowProps } from '../types';

interface Props extends DimensionRowProps {
  valence: Valence;
}

export function DimensionRowBar(props: Props) {
  const { data, negativeColor, positiveColor } = useImpactChartContext();
  const widths = useImpactChartWidths();
  const heights = useImpactChartHeights();
  const baseX =
    props.valence === Valence.NEGATIVE ? widths.title + widths.bars : widths.title + widths.bars + widths.middle;
  const colorOverride = props.valence === Valence.NEGATIVE ? negativeColor : positiveColor;

  const seriesSpacing = heights.dimensionRowSeriesSpacing;
  const barHeight = heights.dimensionRowBarHeight;
  return (
    <Root transform={`translate(${baseX}, ${heights.dimensionRowMargin})`}>
      {data.map((d, index) => {
        const y = index * (barHeight + seriesSpacing) + barHeight / 2;
        return (
          <g key={index} transform={`translate(0, ${y})`}>
            <StackedBar
              data={d.impactScoresByTIVV}
              index={index}
              maxWidth={widths.full}
              dimension={props.dimension}
              height={barHeight}
              valence={props.valence}
              onClick={() => undefined}
              svgId={props.svgId}
              color={colorOverride || d.color}
              noHover
            />
          </g>
        );
      })}
    </Root>
  );
}

const Root = styled.g`
  transition: transform 0.12s ease-in-out;
`;
